// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsGoalsForm_heading__bmwgz","form":"ReportingDetailsGoalsForm_form__ZDRku"};